import { render, staticRenderFns } from "./BodyguardPage.vue?vue&type=template&id=625ddc8c"
import script from "./BodyguardPage.vue?vue&type=script&lang=js"
export * from "./BodyguardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports